import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.4779 1.64718C10.5591 1.38324 10.411 1.10345 10.1471 1.02224C9.88312 0.941034 9.60333 1.08916 9.52212 1.35309L5.52212 14.3531C5.44091 14.617 5.58904 14.8968 5.85297 14.978C6.1169 15.0592 6.39669 14.9111 6.4779 14.6472L10.4779 1.64718Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.85355 4.14657C5.04882 4.34183 5.04882 4.65841 4.85355 4.85368L1.70711 8.00012L4.85355 11.1466C5.04882 11.3418 5.04882 11.6584 4.85355 11.8537C4.65829 12.0489 4.34171 12.0489 4.14645 11.8537L0.646447 8.35368C0.451184 8.15841 0.451184 7.84183 0.646447 7.64657L4.14645 4.14657C4.34171 3.95131 4.65829 3.95131 4.85355 4.14657Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.1464 4.14657C10.9512 4.34183 10.9512 4.65841 11.1464 4.85368L14.2929 8.00012L11.1464 11.1466C10.9512 11.3418 10.9512 11.6584 11.1464 11.8537C11.3417 12.0489 11.6583 12.0489 11.8536 11.8537L15.3536 8.35368C15.5488 8.15841 15.5488 7.84183 15.3536 7.64657L11.8536 4.14657C11.6583 3.95131 11.3417 3.95131 11.1464 4.14657Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}